import React, { Component } from "react"

class Button extends Component {
    constructor() {
        super()
    }

    render = () => {

        const { text, modal, onClick } = this.props

        const style = modal ? "modal" : ""

        return (
            <div className={`button-box ${style}`} onClick={() => onClick()}>
                <p>{text}</p>
            </div>
        )
    }

}

export default Button